<app-navbar></app-navbar>

<section class="py-20 md:py-24 xl:py-32 min-h-[50dvh] bg-white text-black">
    <div class="max-w-5xl mx-auto px-4">
        <h1 class="text-2xl">{{texts.title}}</h1>
        <p class="text-lg mt-4">{{texts.subtitle}}</p>

        <div class="my-5">
            <h2 class="text-xl font-semibold">{{texts.sections[0].title}}</h2>
            <div *ngFor="let item of texts.sections[0].body" class="mt-2">
                <p class="text-base">- {{item}}</p>

            </div>
        </div>

        <div class="my-5">
            <h2 class="text-xl font-semibold">{{texts.sections[1].title}}</h2>
            <div *ngFor="let item of texts.sections[1].body" class="mt-2">
                <p class="text-base">- {{item}}</p>

            </div>
        </div>

        <div class="my-5">
            <h2 class="text-xl font-semibold">{{texts.sections[2].title}}</h2>
            <div *ngFor="let item of texts.sections[2].body" class="mt-2">
                <p class="text-base">- {{item}}</p>

            </div>
        </div>

         <div class="my-5">
            <h2 class="text-xl font-semibold">{{texts.sections[3].title}}</h2>
            <div *ngFor="let item of texts.sections[3].body" class="mt-2">
                <p class="text-base">- {{item}}</p>

            </div>
        </div>

        <div class="my-5">
            <h2 class="text-xl font-semibold">{{texts.sections[4].title}}</h2>
            <div *ngFor="let item of texts.sections[4].body" class="mt-2">
                <p class="text-base">{{item}}</p>

            </div>
        </div>

        <div class="my-5">
            <h2 class="text-xl font-semibold">{{texts.sections[5].title}}</h2>
            <div *ngFor="let item of texts.sections[5].body" class="mt-2">
                <p class="text-base">{{item}}</p>

            </div>
        </div>
        <div class="my-5">
            <h2 class="text-xl font-semibold">{{texts.sections[6].title}}</h2>
            <div *ngFor="let item of texts.sections[6].body" class="mt-2">
                <p class="text-base">{{item}}</p>

            </div>
        </div>
        <div class="my-5">
            <h2 class="text-xl font-semibold">{{texts.sections[7].title}}</h2>
            <div *ngFor="let item of texts.sections[7].body" class="mt-2">
                <p class="text-base">{{item}}</p>

            </div>
        </div>
        <div class="my-5">
            <h2 class="text-xl font-semibold">{{texts.sections[8].title}}</h2>
            <div *ngFor="let item of texts.sections[8].body" class="mt-2">
                <p class="text-base">{{item}}</p>

            </div>
        </div>
        <div class="my-5">
            <h2 class="text-xl font-semibold">{{texts.sections[9].title}}</h2>
            <div *ngFor="let item of texts.sections[9].body" class="mt-2">
                <p class="text-base">{{item}}</p>

            </div>
        </div>
        <div class="my-5">
            <h2 class="text-xl font-semibold">{{texts.sections[10].title}}</h2>
            <div *ngFor="let item of texts.sections[10].body" class="mt-2">
                <p class="text-base">{{item}}</p>

            </div>
        </div>
        <div class="my-5">
            <h2 class="text-xl font-semibold">{{texts.sections[11].title}}</h2>
            <div *ngFor="let item of texts.sections[11].body" class="mt-2">
                <p class="text-base">{{item}}</p>

            </div>
        </div>
        <div class="my-5">
            <h2 class="text-xl font-semibold">{{texts.sections[12].title}}</h2>
            <div *ngFor="let item of texts.sections[12].body" class="mt-2">
                <p class="text-base">{{item}}</p>

            </div>
        </div>
        <div class="my-5">
            <h2 class="text-xl font-semibold">{{texts.sections[13].title}}</h2>
            <div *ngFor="let item of texts.sections[13].body" class="mt-2">
                <p class="text-base">{{item}}</p>

            </div>
        </div>
    </div>
</section>


<app-footer></app-footer>

